import z from 'zod';

export interface FormLockResponse {
    prospectId: string;
    isLocked: boolean;
    lockedByEmail: string;
    lockedAt: Date;
    message: string;
    version: string;
    globalRetainerFileId?: string;
    previewFileId: string | null;
    /** When set, used as the prefix for client PDF download filenames. */
    documentDisplayName?: string | null;
}

export const FormLockRequestSchema = z.object({
    prospectId: z.guid(),
    contactId: z.guid(),
});
export type FormLockRequest = z.infer<typeof FormLockRequestSchema>;

/** Read-only status for the law-firm prospect page. Does not acquire a lock. */
export interface ProspectFormLockStatus {
    isLocked: boolean;
    lockedByEmail: string | null;
    expiresAt: string | null;
}

export function formLockedByClientMessage(email: string): string {
    return `${email} is editing this intake form. Contact changes will be available when they leave.`;
}
